module.exports = __webpack_public_path__ + "img/minus-inactive.c73a2dd0.svg";